import { render, staticRenderFns } from "./covidAnswersDialog.vue?vue&type=template&id=47578330&"
import script from "./covidAnswersDialog.vue?vue&type=script&lang=js&"
export * from "./covidAnswersDialog.vue?vue&type=script&lang=js&"
import style0 from "./covidAnswersDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports